import { useEffect, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const InViewTrigger = ({
  children,
  onVisibilityChange
}) => {
  const targetRef = useRef(null);
  const [hasTriggered, setHasTriggered] = useState(false); // Flag to ensure callback triggers once

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasTriggered) {
          onVisibilityChange(entry.isIntersecting);
          setHasTriggered(true); // Prevent further invocations
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.8 // Adjust this value based on your needs
    });
    const target = targetRef.current;
    if (target) {
      observer.observe(target);
    }
    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
  }, [onVisibilityChange, hasTriggered]);
  return /*#__PURE__*/_jsx("div", {
    ref: targetRef,
    children: children
  });
};
export default InViewTrigger;